export default __webpack_public_path__ + "static/media/x33-logo.1bb1a4fa.png";